import { render, staticRenderFns } from "./EngagementWidgetContent.vue?vue&type=template&id=5395020a&scoped=true"
import script from "./EngagementWidgetContent.vue?vue&type=script&lang=js"
export * from "./EngagementWidgetContent.vue?vue&type=script&lang=js"
import style0 from "./EngagementWidgetContent.vue?vue&type=style&index=0&id=5395020a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5395020a",
  null
  
)

export default component.exports